module.exports = __webpack_public_path__ + "img/background.4dadde52.png";